import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "w-72 border-l border-slate-200 bg-white flex flex-col flex-shrink-0 overflow-hidden"
};
const _hoisted_2 = {
  class: "h-14 px-4 flex items-center justify-between border-b border-slate-200 flex-shrink-0"
};
const _hoisted_3 = {
  class: "text-sm font-semibold text-slate-700"
};
const _hoisted_4 = {
  class: "flex-1 overflow-y-auto"
};
const _hoisted_5 = {
  class: "p-6 text-center border-b border-slate-100"
};
const _hoisted_6 = {
  class: "text-base font-semibold text-slate-800"
};
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-green-500 mt-1.5"
};
const _hoisted_8 = {
  class: "p-4 space-y-4"
};
const _hoisted_9 = {
  class: "flex items-start gap-2"
};
const _hoisted_10 = {
  class: "text-sm text-slate-700 break-all"
};
const _hoisted_11 = {
  class: "flex items-start gap-2"
};
const _hoisted_12 = {
  class: "text-sm text-slate-700 break-all"
};
const _hoisted_13 = {
  class: "flex items-start gap-2"
};
const _hoisted_14 = {
  class: "text-sm text-slate-700 break-all"
};
const _hoisted_15 = {
  class: "flex items-start gap-2"
};
const _hoisted_16 = {
  class: "text-sm text-slate-700 break-all"
};
const _hoisted_17 = {
  class: "flex items-start gap-2"
};
const _hoisted_18 = {
  class: "text-sm text-slate-700 break-all"
};
const _hoisted_19 = {
  key: 2,
  class: "flex items-start gap-2"
};
const _hoisted_20 = {
  class: "text-sm text-slate-700 break-all"
};
const _hoisted_21 = {
  class: "p-6 text-center border-b border-slate-100"
};
const _hoisted_22 = {
  key: 0,
  class: "flex items-center gap-1.5 justify-center mb-1"
};
const _hoisted_23 = {
  key: 1,
  class: "flex items-center justify-center gap-1 mb-1"
};
const _hoisted_24 = {
  class: "text-base font-semibold text-slate-800"
};
const _hoisted_25 = {
  class: "text-xs text-slate-500"
};
const _hoisted_26 = {
  key: 2,
  class: "mt-2 px-2"
};
const _hoisted_27 = {
  class: "flex justify-end gap-1 mt-1"
};
const _hoisted_28 = {
  key: 3,
  class: "mt-1.5 flex items-center justify-center gap-1"
};
const _hoisted_29 = {
  class: "text-xs text-slate-400"
};
const _hoisted_30 = {
  class: "p-4"
};
const _hoisted_31 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_32 = {
  class: "text-xs text-slate-500 font-medium"
};
const _hoisted_33 = {
  class: "space-y-0.5"
};
const _hoisted_34 = {
  class: "flex-1 min-w-0"
};
const _hoisted_35 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_36 = {
  class: "text-sm text-slate-700 truncate"
};
const _hoisted_37 = {
  key: 0,
  class: "px-1 py-0.5 text-[10px] leading-none rounded bg-amber-100 text-amber-600 flex-shrink-0"
};
const _hoisted_38 = {
  key: 1,
  class: "px-1 py-0.5 text-[10px] leading-none rounded bg-blue-100 text-blue-600 flex-shrink-0"
};
const _hoisted_39 = {
  class: "text-[11px] text-slate-400"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  class: "p-4 border-t border-slate-100"
};
const _hoisted_42 = {
  class: "space-y-2"
};
const _hoisted_43 = {
  key: 0,
  class: "p-3 border-t border-slate-200 space-y-2 flex-shrink-0 bg-white"
};
const _hoisted_44 = {
  class: "px-4 py-3 border-b border-slate-200 flex items-center justify-between flex-shrink-0"
};
const _hoisted_45 = {
  class: "px-4 py-2 border-b border-slate-100 flex-shrink-0"
};
const _hoisted_46 = {
  key: 0,
  class: "px-4 py-2 border-b border-slate-100 flex flex-wrap gap-1 flex-shrink-0"
};
const _hoisted_47 = ["onClick"];
const _hoisted_48 = {
  class: "flex-1 overflow-y-auto"
};
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
  key: 0,
  class: "w-3 h-3 text-white",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_51 = {
  class: "min-w-0 flex-1"
};
const _hoisted_52 = {
  class: "text-sm text-slate-700 truncate"
};
const _hoisted_53 = {
  class: "text-[11px] text-slate-400 truncate"
};
const _hoisted_54 = {
  key: 0,
  class: "py-6 text-center text-xs text-slate-400"
};
const _hoisted_55 = {
  class: "px-4 py-3 border-t border-slate-200 flex-shrink-0"
};
const _hoisted_56 = ["disabled"];
const _hoisted_57 = {
  class: "px-4 py-3 border-b border-slate-200 flex items-center justify-between flex-shrink-0"
};
const _hoisted_58 = {
  class: "flex-1 overflow-y-auto"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = {
  class: "min-w-0 flex-1"
};
const _hoisted_61 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_62 = {
  class: "text-sm text-slate-700"
};
const _hoisted_63 = {
  key: 0,
  class: "px-1 py-0.5 text-[10px] leading-none rounded bg-blue-100 text-blue-600"
};
const _hoisted_64 = {
  class: "text-[11px] text-slate-400"
};
import { ref, computed } from 'vue';
import { useChatStore } from '@/stores/chat';
import { useUserStore } from '@/stores/user';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'ChatInfoPanel',
  setup(__props) {
    const chatStore = useChatStore();
    const userStore = useUserStore();
    const conversation = computed(() => chatStore.currentConversation);
    const currentUserId = computed(() => userStore.userInfo?.userId);
    const isOwnerOrAdmin = computed(() => {
      const role = chatStore.currentUserRole;
      return role === 'owner' || role === 'admin';
    });

    // 群名称编辑
    const editingGroupName = ref(false);
    const groupNameInput = ref('');
    function startEditGroupName() {
      groupNameInput.value = conversation.value.name;
      editingGroupName.value = true;
    }
    function saveGroupName() {
      const name = groupNameInput.value.trim();
      if (!name) return;
      chatStore.updateGroupInfo(conversation.value.id, {
        name
      });
      editingGroupName.value = false;
      ElMessage.success('群名称已修改');
    }

    // 群公告编辑
    const editingDescription = ref(false);
    const descriptionInput = ref('');
    function startEditDescription() {
      descriptionInput.value = conversation.value.description || '';
      editingDescription.value = true;
    }
    function saveDescription() {
      chatStore.updateGroupInfo(conversation.value.id, {
        description: descriptionInput.value.trim()
      });
      editingDescription.value = false;
      ElMessage.success('群公告已更新');
    }

    // 成员操作菜单
    const memberMenuVisible = ref(false);
    const memberMenuPos = ref({
      x: 0,
      y: 0
    });
    const activeMember = ref(null);
    function openMemberMenu(e, member) {
      const menuWidth = 150;
      const menuHeight = 140;
      const x = Math.min(e.clientX, window.innerWidth - menuWidth);
      const y = Math.min(e.clientY, window.innerHeight - menuHeight);
      memberMenuPos.value = {
        x,
        y
      };
      activeMember.value = member;
      memberMenuVisible.value = true;
    }
    function handleSetAdmin() {
      chatStore.setMemberRole(conversation.value.id, activeMember.value.id, 'admin');
      memberMenuVisible.value = false;
      ElMessage.success(`已将 ${activeMember.value.name} 设为管理员`);
    }
    function handleCancelAdmin() {
      chatStore.setMemberRole(conversation.value.id, activeMember.value.id, 'member');
      memberMenuVisible.value = false;
      ElMessage.success(`已取消 ${activeMember.value.name} 的管理员身份`);
    }
    function handleRemoveMember() {
      const name = activeMember.value.name;
      ElMessageBox.confirm(`确定将 ${name} 移出群聊吗？`, '移出成员', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        chatStore.removeGroupMember(conversation.value.id, activeMember.value.id);
        memberMenuVisible.value = false;
        ElMessage.success(`已将 ${name} 移出群聊`);
      }).catch(() => {});
    }
    function handleTransferToMember() {
      const member = activeMember.value;
      ElMessageBox.confirm(`确定将群主转让给 ${member.name} 吗？转让后你将成为管理员。`, '转让群主', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        chatStore.transferOwner(conversation.value.id, member.id);
        memberMenuVisible.value = false;
        ElMessage.success(`群主已转让给 ${member.name}`);
      }).catch(() => {});
    }

    // 添加成员
    const showAddMemberPanel = ref(false);
    const addMemberSearch = ref('');
    const selectedNewMembers = ref([]);
    const addableContacts = computed(() => {
      const existingIds = new Set((conversation.value?.members || []).map(m => m.id));
      let list = chatStore.availableContacts.filter(c => !existingIds.has(c.id));
      if (addMemberSearch.value) {
        const keyword = addMemberSearch.value.toLowerCase();
        list = list.filter(c => c.name.toLowerCase().includes(keyword));
      }
      return list;
    });
    function isNewMemberSelected(id) {
      return selectedNewMembers.value.some(m => m.id === id);
    }
    function toggleNewMember(contact) {
      const idx = selectedNewMembers.value.findIndex(m => m.id === contact.id);
      if (idx > -1) {
        selectedNewMembers.value.splice(idx, 1);
      } else {
        selectedNewMembers.value.push(contact);
      }
    }
    function confirmAddMembers() {
      if (selectedNewMembers.value.length === 0) return;
      chatStore.addGroupMembers(conversation.value.id, selectedNewMembers.value);
      ElMessage.success(`已添加 ${selectedNewMembers.value.length} 名成员`);
      selectedNewMembers.value = [];
      addMemberSearch.value = '';
      showAddMemberPanel.value = false;
    }

    // 转让群主面板
    const showTransferPanel = ref(false);
    const transferableMembers = computed(() => {
      return (conversation.value?.members || []).filter(m => String(m.id) !== String(currentUserId.value) && m.role !== 'owner');
    });
    function handleTransferOwner(member) {
      ElMessageBox.confirm(`确定将群主转让给 ${member.name} 吗？转让后你将成为管理员。`, '转让群主', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        chatStore.transferOwner(conversation.value.id, member.id);
        showTransferPanel.value = false;
        ElMessage.success(`群主已转让给 ${member.name}`);
      }).catch(() => {});
    }

    // 解散群聊
    function handleDissolveGroup() {
      ElMessageBox.confirm('解散群聊后，所有群成员将被移出，聊天记录将被清除。确定解散吗？', '解散群聊', {
        confirmButtonText: '解散',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        chatStore.dissolveGroup(conversation.value.id);
        ElMessage.success('群聊已解散');
      }).catch(() => {});
    }

    // 退出群聊
    function handleLeaveGroup() {
      ElMessageBox.confirm('退出群聊后将不再接收此群的消息，确定退出吗？', '退出群聊', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        chatStore.leaveGroup(conversation.value.id);
        ElMessage.success('已退出群聊');
      }).catch(() => {});
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h4", _hoisted_3, _toDisplayString(conversation.value.type === 'group' ? '群聊详情' : '联系人信息'), 1), _createElementVNode("button", {
        class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer",
        onClick: _cache[0] || (_cache[0] = $event => _unref(chatStore).toggleInfoPanel())
      }, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])]), _createElementVNode("div", _hoisted_4, [conversation.value.type !== 'group' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: _normalizeClass(["w-16 h-16 mx-auto rounded-full flex items-center justify-center text-xl font-medium text-white mb-3", conversation.value.type === 'internal' ? 'bg-primary-500' : 'bg-emerald-500'])
      }, _toDisplayString(conversation.value.name.slice(-2)), 3), _createElementVNode("h3", _hoisted_6, _toDisplayString(conversation.value.name), 1), _createElementVNode("span", {
        class: _normalizeClass(["inline-block mt-1.5 px-2 py-0.5 text-xs rounded-full", conversation.value.type === 'internal' ? 'bg-primary-100 text-primary-600' : 'status-badge is-success'])
      }, _toDisplayString(conversation.value.type === 'internal' ? '内部人员' : 'C端客户'), 3), conversation.value.online ? (_openBlock(), _createElementBlock("p", _hoisted_7, "当前在线")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [conversation.value.type === 'internal' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_9, [_cache[18] || (_cache[18] = _createElementVNode("span", {
        class: "text-xs text-slate-400 w-14 flex-shrink-0 pt-0.5"
      }, "部门", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(conversation.value.department || '-'), 1)]), _createElementVNode("div", _hoisted_11, [_cache[19] || (_cache[19] = _createElementVNode("span", {
        class: "text-xs text-slate-400 w-14 flex-shrink-0 pt-0.5"
      }, "职位", -1)), _createElementVNode("span", _hoisted_12, _toDisplayString(conversation.value.position || '-'), 1)])], 64)) : _createCommentVNode("", true), conversation.value.type === 'customer' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_13, [_cache[20] || (_cache[20] = _createElementVNode("span", {
        class: "text-xs text-slate-400 w-14 flex-shrink-0 pt-0.5"
      }, "来源", -1)), _createElementVNode("span", _hoisted_14, _toDisplayString(conversation.value.source || '-'), 1)]), _createElementVNode("div", _hoisted_15, [_cache[21] || (_cache[21] = _createElementVNode("span", {
        class: "text-xs text-slate-400 w-14 flex-shrink-0 pt-0.5"
      }, "客户等级", -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(conversation.value.customerLevel || '-'), 1)])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_cache[22] || (_cache[22] = _createElementVNode("span", {
        class: "text-xs text-slate-400 w-14 flex-shrink-0 pt-0.5"
      }, "手机号", -1)), _createElementVNode("span", _hoisted_18, _toDisplayString(conversation.value.phone || '-'), 1)]), conversation.value.email ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_cache[23] || (_cache[23] = _createElementVNode("span", {
        class: "text-xs text-slate-400 w-14 flex-shrink-0 pt-0.5"
      }, "邮箱", -1)), _createElementVNode("span", _hoisted_20, _toDisplayString(conversation.value.email), 1)])) : _createCommentVNode("", true)]), _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"p-4 border-t border-slate-100\"><p class=\"text-xs text-slate-500 mb-3 font-medium\">快捷操作</p><div class=\"grid grid-cols-3 gap-2\"><button class=\"flex flex-col items-center gap-1.5 p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer\"><div class=\"w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center\"><svg class=\"w-4 h-4 text-blue-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z\"></path></svg></div><span class=\"text-[10px] text-slate-500\">电话</span></button><button class=\"flex flex-col items-center gap-1.5 p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer\"><div class=\"w-8 h-8 rounded-full bg-green-50 flex items-center justify-center\"><svg class=\"w-4 h-4 text-green-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z\"></path></svg></div><span class=\"text-[10px] text-slate-500\">视频</span></button><button class=\"flex flex-col items-center gap-1.5 p-2 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer\"><div class=\"w-8 h-8 rounded-full bg-purple-50 flex items-center justify-center\"><svg class=\"w-4 h-4 text-purple-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z\"></path></svg></div><span class=\"text-[10px] text-slate-500\">主页</span></button></div></div>", 1))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_21, [_cache[29] || (_cache[29] = _createElementVNode("div", {
        class: "w-16 h-16 mx-auto rounded-full bg-violet-500 flex items-center justify-center mb-3"
      }, [_createElementVNode("svg", {
        class: "w-8 h-8 text-white",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
      })])], -1)), editingGroupName.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => groupNameInput.value = $event),
        class: "text-base font-semibold text-slate-800 text-center border-b border-primary-400 outline-none bg-transparent w-36",
        onKeydown: [_withKeys(saveGroupName, ["enter"]), _cache[2] || (_cache[2] = _withKeys($event => editingGroupName.value = false, ["escape"]))]
      }, null, 544), [[_vModelText, groupNameInput.value]]), _createElementVNode("button", {
        class: "p-0.5 text-primary-500 hover:text-primary-600 cursor-pointer",
        onClick: saveGroupName
      }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M5 13l4 4L19 7"
      })], -1)]))]), _createElementVNode("button", {
        class: "p-0.5 text-slate-400 hover:text-slate-600 cursor-pointer",
        onClick: _cache[3] || (_cache[3] = $event => editingGroupName.value = false)
      }, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])])) : (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("h3", _hoisted_24, _toDisplayString(conversation.value.name), 1), isOwnerOrAdmin.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "p-0.5 text-slate-300 hover:text-slate-500 cursor-pointer",
        title: "修改群名称",
        onClick: startEditGroupName
      }, [...(_cache[27] || (_cache[27] = [_createElementVNode("svg", {
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
      })], -1)]))])) : _createCommentVNode("", true)])), _createElementVNode("p", _hoisted_25, _toDisplayString(conversation.value.memberCount) + " 名成员", 1), editingDescription.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => descriptionInput.value = $event),
        class: "form-textarea text-xs leading-snug",
        rows: "2",
        placeholder: "输入群公告..."
      }, null, 512), [[_vModelText, descriptionInput.value]]), _createElementVNode("div", _hoisted_27, [_createElementVNode("button", {
        class: "px-2 py-0.5 text-xs text-slate-500 hover:text-slate-700 cursor-pointer",
        onClick: _cache[5] || (_cache[5] = $event => editingDescription.value = false)
      }, "取消"), _createElementVNode("button", {
        class: "px-2 py-0.5 text-xs text-white bg-primary-500 hover:bg-primary-600 rounded cursor-pointer",
        onClick: saveDescription
      }, "保存")])])) : (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("p", _hoisted_29, _toDisplayString(conversation.value.description || '暂无群公告'), 1), isOwnerOrAdmin.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "p-0.5 text-slate-300 hover:text-slate-500 cursor-pointer",
        title: "编辑群公告",
        onClick: startEditDescription
      }, [...(_cache[28] || (_cache[28] = [_createElementVNode("svg", {
        class: "w-3 h-3",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
      })], -1)]))])) : _createCommentVNode("", true)]))]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("p", _hoisted_32, "群成员 (" + _toDisplayString(conversation.value.members?.length || 0) + ")", 1)]), _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conversation.value.members, member => {
        return _openBlock(), _createElementBlock("div", {
          key: member.id,
          class: "flex items-center gap-2.5 p-2 rounded-lg hover:bg-slate-50 transition-colors relative"
        }, [_createElementVNode("div", {
          class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium text-white flex-shrink-0", member.role === 'owner' ? 'bg-amber-500' : member.role === 'admin' ? 'bg-primary-500' : 'bg-slate-400'])
        }, _toDisplayString(member.name.slice(-1)), 3), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(member.name), 1), member.role === 'owner' ? (_openBlock(), _createElementBlock("span", _hoisted_37, "群主")) : member.role === 'admin' ? (_openBlock(), _createElementBlock("span", _hoisted_38, "管理员")) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_39, _toDisplayString(member.department), 1)]), isOwnerOrAdmin.value && String(member.id) !== String(currentUserId.value) && member.role !== 'owner' ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "p-1 text-slate-300 hover:text-slate-600 hover:bg-slate-100 rounded transition-colors cursor-pointer",
          onClick: _withModifiers($event => openMemberMenu($event, member), ["stop"])
        }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
        })], -1)]))], 8, _hoisted_40)) : _createCommentVNode("", true)]);
      }), 128))]), isOwnerOrAdmin.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "mt-3 w-full flex items-center justify-center gap-1.5 py-2 border border-dashed border-slate-300 rounded-lg text-xs text-slate-500 hover:text-primary-500 hover:border-primary-300 transition-colors cursor-pointer",
        onClick: _cache[6] || (_cache[6] = $event => showAddMemberPanel.value = true)
      }, [...(_cache[31] || (_cache[31] = [_createElementVNode("svg", {
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
      })], -1), _createTextVNode(" 添加成员 ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_41, [_cache[34] || (_cache[34] = _createElementVNode("p", {
        class: "text-xs text-slate-500 mb-3 font-medium"
      }, "群聊设置", -1)), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
        class: "flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 cursor-pointer",
        onClick: _cache[7] || (_cache[7] = $event => _unref(chatStore).muteConversation(conversation.value.id))
      }, [_cache[32] || (_cache[32] = _createElementVNode("span", {
        class: "text-sm text-slate-600"
      }, "消息免打扰", -1)), _createElementVNode("div", {
        class: _normalizeClass(["w-8 h-5 rounded-full relative cursor-pointer transition-colors", _unref(chatStore).isConversationMuted(conversation.value.id) ? 'bg-primary-500' : 'bg-slate-200'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["w-4 h-4 rounded-full bg-white shadow-sm absolute top-0.5 transition-transform", _unref(chatStore).isConversationMuted(conversation.value.id) ? 'translate-x-3' : 'translate-x-0.5'])
      }, null, 2)], 2)]), _createElementVNode("div", {
        class: "flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 cursor-pointer",
        onClick: _cache[8] || (_cache[8] = $event => _unref(chatStore).pinConversation(conversation.value.id))
      }, [_cache[33] || (_cache[33] = _createElementVNode("span", {
        class: "text-sm text-slate-600"
      }, "置顶聊天", -1)), _createElementVNode("div", {
        class: _normalizeClass(["w-8 h-5 rounded-full relative cursor-pointer transition-colors", _unref(chatStore).isConversationPinned(conversation.value.id) ? 'bg-primary-500' : 'bg-slate-200'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["w-4 h-4 rounded-full bg-white shadow-sm absolute top-0.5 transition-transform", _unref(chatStore).isConversationPinned(conversation.value.id) ? 'translate-x-3' : 'translate-x-0.5'])
      }, null, 2)], 2)])])])], 64))]), conversation.value.type === 'group' ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_unref(chatStore).currentUserRole === 'owner' ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "w-full flex items-center justify-center gap-1.5 py-2 text-sm text-amber-600 hover:bg-amber-50 rounded-lg transition-colors cursor-pointer",
        onClick: _cache[9] || (_cache[9] = $event => showTransferPanel.value = true)
      }, [...(_cache[35] || (_cache[35] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
      })], -1), _createTextVNode(" 转让群主 ", -1)]))])) : _createCommentVNode("", true), _unref(chatStore).currentUserRole === 'owner' ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "w-full flex items-center justify-center gap-1.5 py-2 text-sm text-red-500 hover:bg-red-50 rounded-lg transition-colors cursor-pointer",
        onClick: handleDissolveGroup
      }, [...(_cache[36] || (_cache[36] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      })], -1), _createTextVNode(" 解散群聊 ", -1)]))])) : _createCommentVNode("", true), _unref(chatStore).currentUserRole !== 'owner' ? (_openBlock(), _createElementBlock("button", {
        key: 2,
        class: "w-full flex items-center justify-center gap-1.5 py-2 text-sm text-red-500 hover:bg-red-50 rounded-lg transition-colors cursor-pointer",
        onClick: handleLeaveGroup
      }, [...(_cache[37] || (_cache[37] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
      })], -1), _createTextVNode(" 退出群聊 ", -1)]))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [memberMenuVisible.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-[100]",
        onClick: _cache[10] || (_cache[10] = $event => memberMenuVisible.value = false),
        onContextmenu: _cache[11] || (_cache[11] = _withModifiers($event => memberMenuVisible.value = false, ["prevent"]))
      }, [_createElementVNode("div", {
        class: "absolute bg-white rounded-lg shadow-lg border border-slate-200 py-1 min-w-[130px] z-[101]",
        style: _normalizeStyle({
          left: memberMenuPos.value.x + 'px',
          top: memberMenuPos.value.y + 'px'
        })
      }, [_unref(chatStore).currentUserRole === 'owner' && activeMember.value?.role !== 'admin' ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "w-full px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-50 text-left flex items-center gap-2 cursor-pointer",
        onClick: handleSetAdmin
      }, [...(_cache[38] || (_cache[38] = [_createElementVNode("svg", {
        class: "w-4 h-4 text-blue-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
      })], -1), _createTextVNode(" 设为管理员 ", -1)]))])) : _createCommentVNode("", true), _unref(chatStore).currentUserRole === 'owner' && activeMember.value?.role === 'admin' ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "w-full px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-50 text-left flex items-center gap-2 cursor-pointer",
        onClick: handleCancelAdmin
      }, [...(_cache[39] || (_cache[39] = [_createElementVNode("svg", {
        class: "w-4 h-4 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"
      })], -1), _createTextVNode(" 取消管理员 ", -1)]))])) : _createCommentVNode("", true), _unref(chatStore).currentUserRole === 'owner' ? (_openBlock(), _createElementBlock("button", {
        key: 2,
        class: "w-full px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-50 text-left flex items-center gap-2 cursor-pointer",
        onClick: handleTransferToMember
      }, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
        class: "w-4 h-4 text-amber-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
      })], -1), _createTextVNode(" 转让群主 ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("button", {
        class: "w-full px-3 py-1.5 text-sm text-red-500 hover:bg-red-50 text-left flex items-center gap-2 cursor-pointer",
        onClick: handleRemoveMember
      }, [...(_cache[41] || (_cache[41] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6"
      })], -1), _createTextVNode(" 移出群聊 ", -1)]))])], 4)], 32)) : _createCommentVNode("", true)])), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: showAddMemberPanel.value,
        size: "none",
        "panel-class": "w-80 max-h-[70vh]",
        scrollable: false,
        onClose: _cache[14] || (_cache[14] = $event => showAddMemberPanel.value = false)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_cache[43] || (_cache[43] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-700"
        }, "添加群成员", -1)), _createElementVNode("button", {
          class: "p-1 text-slate-400 hover:text-slate-600 cursor-pointer",
          onClick: _cache[12] || (_cache[12] = $event => showAddMemberPanel.value = false)
        }, [...(_cache[42] || (_cache[42] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_45, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => addMemberSearch.value = $event),
          class: "form-search-input form-control-sm",
          placeholder: "搜索联系人..."
        }, null, 512), [[_vModelText, addMemberSearch.value]])]), selectedNewMembers.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedNewMembers.value, m => {
          return _openBlock(), _createElementBlock("span", {
            key: m.id,
            class: "inline-flex items-center gap-1 px-2 py-0.5 bg-primary-50 text-primary-600 text-xs rounded-full"
          }, [_createTextVNode(_toDisplayString(m.name) + " ", 1), _createElementVNode("button", {
            class: "hover:text-primary-800 cursor-pointer",
            onClick: $event => toggleNewMember(m)
          }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
            class: "w-3 h-3",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_47)]);
        }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_48, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addableContacts.value, contact => {
          return _openBlock(), _createElementBlock("div", {
            key: contact.id,
            class: "flex items-center gap-2.5 px-4 py-2 hover:bg-slate-50 cursor-pointer transition-colors",
            onClick: $event => toggleNewMember(contact)
          }, [_createElementVNode("div", {
            class: _normalizeClass(["w-5 h-5 rounded border flex items-center justify-center flex-shrink-0 transition-colors", isNewMemberSelected(contact.id) ? 'bg-primary-500 border-primary-500' : 'border-slate-300'])
          }, [isNewMemberSelected(contact.id) ? (_openBlock(), _createElementBlock("svg", _hoisted_50, [...(_cache[45] || (_cache[45] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          }, null, -1)]))])) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
            class: _normalizeClass(["w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-medium text-white flex-shrink-0", contact.type === 'internal' ? 'bg-primary-400' : 'bg-emerald-400'])
          }, _toDisplayString(contact.name.slice(-1)), 3), _createElementVNode("div", _hoisted_51, [_createElementVNode("p", _hoisted_52, _toDisplayString(contact.name), 1), _createElementVNode("p", _hoisted_53, _toDisplayString(contact.department || contact.source || ''), 1)])], 8, _hoisted_49);
        }), 128)), addableContacts.value.length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_54, "没有可添加的联系人")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_55, [_createElementVNode("button", {
          class: _normalizeClass(["w-full py-2 text-sm rounded-lg transition-colors cursor-pointer", selectedNewMembers.value.length > 0 ? 'bg-primary-500 text-white hover:bg-primary-600' : 'bg-slate-100 text-slate-400 cursor-not-allowed']),
          disabled: selectedNewMembers.value.length === 0,
          onClick: confirmAddMembers
        }, " 确认添加 (" + _toDisplayString(selectedNewMembers.value.length) + ") ", 11, _hoisted_56)])]),
        _: 1
      }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: showTransferPanel.value,
        size: "none",
        "panel-class": "w-80 max-h-[60vh]",
        scrollable: false,
        onClose: _cache[16] || (_cache[16] = $event => showTransferPanel.value = false)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_57, [_cache[47] || (_cache[47] = _createElementVNode("h4", {
          class: "text-sm font-semibold text-slate-700"
        }, "转让群主", -1)), _createElementVNode("button", {
          class: "p-1 text-slate-400 hover:text-slate-600 cursor-pointer",
          onClick: _cache[15] || (_cache[15] = $event => showTransferPanel.value = false)
        }, [...(_cache[46] || (_cache[46] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _cache[48] || (_cache[48] = _createElementVNode("p", {
          class: "px-4 py-2 text-xs text-slate-400 border-b border-slate-100 flex-shrink-0"
        }, "选择一位成员作为新群主，转让后你将成为管理员", -1)), _createElementVNode("div", _hoisted_58, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transferableMembers.value, member => {
          return _openBlock(), _createElementBlock("div", {
            key: member.id,
            class: "flex items-center gap-2.5 px-4 py-2.5 hover:bg-slate-50 cursor-pointer transition-colors",
            onClick: $event => handleTransferOwner(member)
          }, [_createElementVNode("div", {
            class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium text-white flex-shrink-0", member.role === 'admin' ? 'bg-primary-500' : 'bg-slate-400'])
          }, _toDisplayString(member.name.slice(-1)), 3), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(member.name), 1), member.role === 'admin' ? (_openBlock(), _createElementBlock("span", _hoisted_63, "管理员")) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_64, _toDisplayString(member.department), 1)])], 8, _hoisted_59);
        }), 128))])]),
        _: 1
      }, 8, ["visible"])]))]);
    };
  }
};